"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _CouponSendConfig = _interopRequireDefault(require("../CouponSend/CouponSendConfig.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PrivateAreaConfigPane',
  components: {
    CouponSendConfig: _CouponSendConfig.default
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    sendType: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handleSuccess: function handleSuccess() {
      this.$emit('success');
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};